var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[(_vm.computedPath)?_c('h2',{staticClass:"page-titles"},[_vm._v("\n    Edit redemption page\n  ")]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }